export default __webpack_public_path__ + "static/media/Vectormedium.889e0c38.svg";